export default {
  namespaced: true, 
  state: () => ({   
    username: null,
    token: null,
    phone: null 
  }),
  mutations: {
    SET_USER(state, payload) {
      state.username = payload.username
      state.token = payload.token
      if (payload.phone !== undefined) { // 添加对 phone 的处理
         state.phone = payload.phone
      }
    }
  },
  actions: {
    setUser({ commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          // 在 commit 之前添加日志
          console.log('Action setUser: Attempting to commit SET_USER with payload:', payload);
          commit('SET_USER', payload); 
          resolve();
        } catch (error) {
          // 添加错误日志
          console.error('Action setUser: Error during commit:', error);
          reject(error);
        }
      });
    }
  }
}